import registry from "~/components/DoRegistry.js";
import DoAjax from "~/components/ajax/DoAjax.js";
import DoModal from "~/components/modal/DoModal.js";
import DoFlash from "~/components/flashmsg/DoFlash.js";
import template from './list.hbs';
import deleteMsg from './deleteMsg.hbs';

//assumes jQuery and Datatables are on window object.

var dtSettings = {
    "dom": 'lf<"dataTableNav">rtip',
    "autoWidth": false,
    "iDisplayLength": 10,
    "oLanguage": {
        "sLengthMenu": '<select>'+
        '<option value="10">Show 10 Per Page</option>'+
        '<option value="25">Show 25 Per Page</option>'+
        '<option value="50">Show 50 Per Page</option>'+
        '<option value="-1">Show All</option>'+
        '</select>'
    },
}

let ajax = new DoAjax();

let modalSettings = {
    width: '350px',
    height: 'auto',
    ok: 'Yes, Delete',
    cancel : 'No, Cancel'
}

class Page {
    constructor($target, createCb, viewCb, editCb, deleteCb){
        this.$target = $target;
        this.modal = new DoModal('RfpLegendListPageModal', '<p>Are you sure you want to delete this item?</p>', modalSettings);
        this.flash = new DoFlash($target);
        this.viewCb = viewCb;
        this.editCb = editCb;
        this.createCb = createCb;
        this.deleteCb = deleteCb;
    }

    deleteEntry(id){
        let result = ajax.doDelete('/d/user/map/legend/'+id);

        result.done(()=>{
            this.flash.flash("success", "Icon label set removed");
            this.$table.DataTable().row('[data-id="'+id+'"]').remove().draw();
            this.modal.hide();
        });

        this.deleteCb(result);

        return result;
    }

    render(url){

        let self = this;
        let result = ajax.page(this.$target, url);

        result
            .done((data)=>{
                self.$target.html(template(data));

                self.$table = self.$target.find('>table');

                self.$table.on('draw.dt', ()=>{
                    //add callbacks if set
                    if(self.viewCb) self.$target.find('.row-view').off('click').click(function(e){e.preventDefault(); self.viewCb($(this).attr('data-id'));});
                    if(self.editCb) self.$target.find('.row-edit').off('click').click(function(e){e.preventDefault(); self.editCb($(this).attr('data-id'));});

                    self.$table.find('a.row-delete').off('click').click(function(e){
                        e.preventDefault();

                        let id = $(this).attr('data-id');
                        let name = $(this).attr('data-name');

                        self.modal.content(deleteMsg({name:name}))
                        self.modal.show(()=>{self.deleteEntry(id)});
                    });
                });

                self.$table.dataTable(dtSettings);

                //I would rather put this into the page, but jspx hates html characters, so put it here
                self.$target.find("div.dataTableNav").html('<nav id="horizNav"><ul><li><a id="rfpLegendCreateLink" href="0/create"><span class="fa-stack fa-lg" aria-hidden="true"><i class="fa fa-square fa-stack-2x"></i><i class="fa fa-plus fa-stack-1x fa-inverse"></i></span> Create New Icon Label Set</a></li></ul></nav>');

                if(self.createCb) self.$target.find("#rfpLegendCreateLink").off('click').click(function(e){e.preventDefault(); self.createCb();});

            });

        return result;
    }
}

registry.register(__filename, Page);
export default Page;